import * as constants from "./constants";

const initialState = {
  dashboardRegisters: [],
  fetchingLoading: true,
  totalRecords: 0,
  error: null,
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.FETCH_DASHBOARD_REGISTERS:
      return {
        ...state,
        fetchingLoading: true,
        error: null,
      };

    case constants.FETCH_DASHBOARD_REGISTERS_SUCCESS:
      const responseData = action.data;
      const isArray = Array.isArray(responseData);
      const registers = isArray ? responseData : (responseData?.data || []);
      const total = isArray ? responseData.length : (responseData?.meta?.total || responseData?.total || 0);

      return {
        ...state,
        dashboardRegisters: Array.isArray(registers) ? registers : [],
        fetchingLoading: false,
        totalRecords: total,
      };

    case constants.FETCH_DASHBOARD_REGISTERS_ERROR:
      return {
        ...state,
        fetchingLoading: false,
        error: action.error,
      };

    default:
      return state;
  }
};

export default dashboardReducer;
